import React, { useState, useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import { FormInputWrapper, FormInputLabelWrapperStyled, FormInputLabelStyled, FormInputStyled, FormInputError, StyledIcon } from './styled'

const FromInputFocus = ({ placeholder, label, placeholderFocused, type, name, onChange, onFocus, onBlur, value, error, icon, fullWidth, marginVertical, initialFocused }) => {

  const [focused, setFocus] = useState(false)
  const ref = useRef(null)

  useEffect(() => {
      setFocus(initialFocused)
  }, [initialFocused])

  useEffect(() => {
    if(focused) {
      ref.current.focus()
    }
  }, [focused])

  const handleFocus = () => {
    setFocus(true)
    onFocus && onFocus()
  }

  const handleBlur = () => {
    setFocus(false)
    onBlur && onBlur()
  }

  return (
    <FormInputWrapper
      error={error}
      fullWidth={fullWidth}
    >
      <FormInputLabelWrapperStyled>
        {label && <FormInputLabelStyled>{label}</FormInputLabelStyled>}
        {icon && <StyledIcon name={icon} focused={focused} />}
        <FormInputStyled
          ref={ref}
          placeholder={focused ? placeholderFocused : placeholder}
          onFocus={handleFocus}
          onBlur={handleBlur}
          type={type}
          name={name}
          onChange={onChange}
          value={value}
          icon={!!icon}
          focused={focused}
          marginVertical={marginVertical}
          autoComplete="off"
        />
        {error && <FormInputError>{error}</FormInputError>}
      </FormInputLabelWrapperStyled>
    </FormInputWrapper>
  )
}

FromInputFocus.propTypes = {
  placeholder: PropTypes.string,
  label: PropTypes.string,
  placeholderFocused: PropTypes.string,
  type: PropTypes.string,
  name: PropTypes.string,
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  value: PropTypes.string,
  error: PropTypes.string,
  icon: PropTypes.string,
  focus: PropTypes.bool,
  fullWidth: PropTypes.bool,
  marginVertical: PropTypes.bool
}

FromInputFocus.defaultProps = {
  placeholder: '',
  label: '',
  placeholderFocused: '',
  type: 'text',
  name: 'input',
  onChange: () => { },
  onFocus: () => { },
  onBlur: () => { },
  value: '',
  error: '',
  icon: '',
  focus: false,
  fullWidth: false,
  marginVertical: false
}

export default FromInputFocus